import React, { useEffect, useState } from 'react';
import moment from 'moment';
import truncate from 'lodash/truncate';
import { Link } from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import useComparable from '~/commons/hooks/useComparable';
import PageHttp from '~/commons/components/PageHttp.jsx';
import ListPagination from '~/commons/components/ListPagination.jsx';
import meta from '../../config/meta';
import BtnLimit from '../btns/BtnLimit.jsx';
import BtnSort from '../btns/BtnSort.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';
import Header from '../layout/Header.jsx';

const SharesGridView = ({rows}) => (
    <div className="row assignments-grid mt-n3">
    {rows.map((r) => {
      const href = `/shares/${r._id}`;

      return (
        <div
          key={r._id}
          className="col-12 col-lg-6 col-xl-4 mt-3"
        >
          <div className="ratio-standard position-relative bg-light">
            {r.coverImg && (
              <Link
                to={href}
              >
                <div
                  className="img-bg-cover"
                  style={{ backgroundImage: `url(${r.coverImg})` }}
                ></div>
              </Link>
            )}
          </div>
          <div className="p-3">
            <Link
              to={href}
            >
              <h4>{r.title}</h4>
            </Link>
            <p className="py-3">
              {truncate(r.contentText, {
                length: 60,
                omission: '……',
              })}
            </p>
            <div className="text-right">
              <Link
                to={href}
                className="btn btn-primary px-4 py-2"
              >
                <span className="mr-3">
                  閱讀分享
                </span>
                &nbsp;
                <img
                  src='/assets/img/long-arrow-right.svg'
                  style={{ width: '38px', height: '9px' }}
                />
              </Link>
            </div>
          </div>
        </div>
      );
    })}
  </div>    
)


const SharesListView = ({rows}) => (
    <div className="container-fluid border-top my-4">
    {rows.map((r) => {
      const href = `/shares/${r._id}`;

      return (
        <div
          key={r._id}
          className="row border-bottom py-4 py-md-3 align-items-center"
        >
          <div className="col">
            <div className="row align-items-center">
              <div className="col-12 col-lg">
                <h4>
                  {r.title}
                </h4>
                <p className="mb-2">
                  {truncate(r.contentText, {
                    length: 60,
                    omission: '……',
                  })}
                </p>
              </div>
              <div className="col-auto">
                <Link
                  to={href}
                  className="btn btn-primary px-4 py-2"
                >
                  <span className="mr-3">
                  閱讀分享
                  </span>
                  &nbsp;
                  <img
                    src='/assets/img/long-arrow-right.svg'
                    style={{ width: '38px', height: '9px' }}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </div>    
)

const PageShares = () => {
  const [res, req, fetched = { total: 0 }] = useHttpStatus();
  const [query, setQuery] = useState({
    skip: 0,
    sort: { order: -1, title: 1, createdAt: -1 },
    limit: 20,
  });
  const [mode, setMode] = useState('grid');
  meta.set({ title: '用家分享' });

  useEffect(() => {
    req({
      url: '/api/site/shares',
      params: {
        ...query,
      },
    });
  }, [useComparable(query)]);

  return (
    <div>
      <div className="jumbotron jumbotron-fluid position-relative vh-50 m-0" style={{maxHeight: "250px"}}>
        <div className="img-bg-cover" style={{backgroundImage: "url(/uploads/GkJSq33X2.jpg)"}}></div>
        <div className="pos-abs-center bg-white px-5 py-2">
            <h1 className="m-0">
                <div className="small-sm smaller-xs">用家分享</div>
            </h1>
        </div>
      </div>        
      <div className="container py-4">
        {fetched && (
        <h4 className="text-center text-primary">
          共有{fetched.total}篇分享
        </h4>            
        )}
        {/* controls */}
        <div className="form-row justify-content-between my-3">
          <div className="col-auto">
            <div className="form-row">
              <div className="col-auto my-2">
                <BtnLimit query={query} onQuery={setQuery} />
              </div>
              <div className="col-auto my-2">
                <ListPagination
                  size="sm"
                  {...{
                    ...query,
                    total: fetched.total,
                    onChange: (p) => setQuery({ ...query, ...p }),
                  }}
                />
              </div>
            </div>
          </div>
            <div className="col-auto my-3">
                <div className="form-row">
                    <div className="col-auto">
                    <button
                        className="btn btn-link p-0"
                        onClick={() => setMode('grid')}
                    >
                        <img
                        src={`/assets/img/grid_view_${mode === 'grid' ? '' : 'in'}active.svg`}
                        style={{ width: '35px' }}
                        />
                        <small className="d-block mt-1">
                        <small>預覽模式</small>
                        </small>
                    </button>
                    </div>
                    <div className="col-auto">
                    <button
                        className="btn btn-link p-0"
                        onClick={() => setMode('list')}
                    >
                        <img
                        src={`/assets/img/list_view_${mode === 'list' ? '' : 'in'}active.svg`}
                        style={{ width: '35px' }}
                        />
                        <small className="d-block mt-1">
                        <small>列表模式</small>
                        </small>
                    </button>
                    </div>
                </div>
            </div>
        </div>
        <PageHttp res={res}>
          {({ rows }) => ( mode == 'grid' 
            ? <SharesGridView rows={rows} />
            : <SharesListView rows={rows} />
          )}
        </PageHttp>
        <div className="row justify-content-end">
            <div className="col-auto">
                <ListPagination
                  size="sm"
                  {...{
                    ...query,
                    total: fetched.total,
                    onChange: (p) => {
                      console.log( 'onChange', p );
                      setQuery({ ...query, ...p })
                    }
                  }}
                />
            </div>
        </div>

      </div>
    </div>
  );
};

export default PageShares;
